/* OPTI launcher i18n — safe version without global DOM observer. */
(function () {
  'use strict';

  var copy = {
    fr: { open: 'Ouvrir OPTI, assistant pneus', close: 'Fermer OPTI, assistant pneus', label: 'Assistant pneus IA' },
    en: { open: 'Open OPTI, AI tyre assistant', close: 'Close OPTI, AI tyre assistant', label: 'AI tyre assistant' },
    de: { open: 'OPTI öffnen, KI-Reifenassistent', close: 'OPTI schließen, KI-Reifenassistent', label: 'KI-Reifenassistent' },
    es: { open: 'Abrir OPTI, asistente de neumáticos con IA', close: 'Cerrar OPTI, asistente de neumáticos con IA', label: 'Asistente de neumáticos con IA' },
    it: { open: 'Apri OPTI, assistente pneumatici IA', close: 'Chiudi OPTI, assistente pneumatici IA', label: 'Assistente pneumatici IA' },
    nl: { open: 'Open OPTI, AI-bandenassistent', close: 'Sluit OPTI, AI-bandenassistent', label: 'AI-bandenassistent' }
  };

  function language() {
    var value = document.documentElement.lang ||
      (window.Shopify && window.Shopify.locale) || 'fr';
    return String(value).toLowerCase().split('-')[0];
  }

  function applyLauncherCopy() {
    var launcher = document.querySelector('.opti-chat__launcher');
    if (!launcher) return false;

    var texts = copy[language()] || copy.fr;
    var expanded = launcher.getAttribute('aria-expanded') === 'true';
    launcher.setAttribute('aria-label', expanded ? texts.close : texts.open);

    var visibleLabel = launcher.querySelector('.opti-chat__launcher-label small');
    if (visibleLabel) visibleLabel.textContent = texts.label;

    if (launcher.getAttribute('data-opti-i18n-bound') !== '1') {
      launcher.setAttribute('data-opti-i18n-bound', '1');
      launcher.addEventListener('click', function () {
        window.setTimeout(applyLauncherCopy, 0);
      });
    }
    return true;
  }

  function start() {
    if (applyLauncherCopy()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (applyLauncherCopy() || attempts >= 40) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();